import { render, staticRenderFns } from "./GalleryYear.vue?vue&type=template&id=f3c153b8&"
import script from "./GalleryYear.vue?vue&type=script&lang=js&"
export * from "./GalleryYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports